import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/legal-welfare-and-taxes-mock/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/legal-welfare-and-taxes-mock/statutory-standards'
    });
  }
});